<template>
  <v-tabs
    v-model="tab"
    light
    fixed-tabs
    background-color="accent"
    color="primary"
  >
    <v-tabs-slider></v-tabs-slider>

    <v-tab :href="
    `#tab-1`">
      Tutti i Media
    </v-tab>

    <v-tab :href="`#tab-2`">
      Carica Media
    </v-tab>

    <v-tab-item :value="`tab-1`">
      <media-list></media-list>
    </v-tab-item>

    <v-tab-item :value="`tab-2`">
      <media-upload></media-upload>
    </v-tab-item>
  </v-tabs>
</template>

<script>
  import MediaUpload from './../components/media/MediaUpload'
  import MediaList from './../components/media/MediaList'

  export default {
    name: 'Media',
    components: {
      MediaUpload,
      MediaList
    },
    data() {
      return {
        tab: null
      }
    },
  }
</script>
